import React, { useEffect, useState } from "react";
import PageBar from "./page-bar/PageBar";
import DashboardStats from "./dashboard-stats/DashboardStats";
import RecentRegisterJobs from "./recent-register-jobs/RecentRegisterJobs";
import RecentRegisterUsers from "./recent-register-users/RecentRegisterUsers";
import { getDashboardApi } from "../apifile/ApiFiles";
import { Loaders } from "../../pages/Loaders";
const Dashboard = ({ loginPageData }) => {
  const [loader, setLoader] = useState(false)
  const [dashboardData, setDashboarddata] = useState([])
  // console.log(dashboardData);

  const getDashboard = async () => {
    setLoader(true)
    try {

      const res = await getDashboardApi()
      // console.log(res?.data);
      if (res?.data?.error == false) {
        setDashboarddata(res?.data?.data)
        setLoader(false)
      } else {
        setLoader(false)
      }


    } catch (error) {
      setLoader(false)
    }
  }


  useEffect(() => {
    getDashboard()
  }, [])
  return (
    <>
      {loader && <Loaders />}
      <div className="pageWrapper">
        <PageBar title={`${loginPageData?.data?.name ? loginPageData?.data?.name : ''} Recruiting Your Requirements Admin Panel`} />
        <h3 className="page-title">
          {loginPageData?.data?.name ? loginPageData?.data?.name : ''} Recruiting Dashboard{" "}
          {/* <small>{loginPageData?.data?.name ? loginPageData?.data?.name : 'Abaris'} Recruiting Dashboard</small>{" "} */}
        </h3>
        <DashboardStats dashboardData={dashboardData} />
        <div className="recentDash">
          <div className="row">
            <div className="col-md-12">
              <RecentRegisterUsers dashboardData={dashboardData} />
            </div>
            <div className="col-md-12">
              <RecentRegisterJobs dashboardData={dashboardData} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
